var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnpublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FFAFB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6444 26.6156C36.6444 27.0446 36.9919 27.3939 37.4218 27.3939C37.8503 27.3939 38.1992 27.0446 38.1992 26.6156C38.1992 19.101 32.1052 13 24.5992 13C17.0932 13 10.9992 19.101 10.9992 26.6156C10.9992 27.0446 11.3467 27.3939 11.7766 27.3939C12.2051 27.3939 12.554 27.0446 12.554 26.6156C12.554 19.9588 17.9515 14.5566 24.5992 14.5566C31.2485 14.5566 36.6444 19.9603 36.6444 26.6156ZM24.5992 18.9316C19.6182 18.9316 15.5754 22.9795 15.5754 27.9658C15.5754 32.9525 19.6186 37 24.5992 37C29.5802 37 33.623 32.9521 33.623 27.9658C33.623 22.9791 29.5798 18.9316 24.5992 18.9316ZM24.5992 20.4882C28.722 20.4882 32.0698 23.8387 32.0698 27.9658C32.0698 32.0929 28.7231 35.4449 24.5992 35.4449C20.4765 35.4449 17.1302 32.0945 17.1302 27.9658C17.1302 23.8383 20.4768 20.4882 24.5992 20.4882ZM19.0766 24.5681C18.6864 24.3883 18.2241 24.5593 18.0459 24.9499C17.8663 25.3405 18.0386 25.8033 18.4273 25.9817L24.2756 28.6718C24.6657 28.8517 25.128 28.6807 25.3062 28.2901C25.4858 27.8994 25.315 27.4366 24.9249 27.2582L19.0781 24.5681H19.0766Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnpublish);
export default __webpack_public_path__ + "static/media/iconUnpublish.f0305762d9e764c8a51b0e9b1a89e436.svg";
export { ForwardRef as ReactComponent };